import React from "react";
import Link from "gatsby-link";
import Icon from "../Icon";

const BackBanner = ({ page }) => {
  //builds route back from page.route
  // const pattern = /^\/(.*)\//;
  // let route = pattern.exec(page.route)[1];
  // route = route.replace('-', ' ');
  let route;
  let string = page.route;
  let substring = "friday-cheers";

  if (string.includes(substring)) {
    if (string === '/our-events/friday-cheers-2023/lineup/') {
      route = "/our-events/friday-cheers/";
    } else {
      page.section = "Friday Cheers";
      const strings = page.route.split("/");
      const parts = strings.filter(p => p != "");
      parts.length = 2;
      const buildRoute = parts.join("/");
      route = `/${buildRoute}/`;
    }
  } else {
    route = "/about-us/";
  }

  return (
    <div className="banner--back flex flex-column w-100 mw-1060">
      <Link
        to={route}
        className="banner--back__link flex items-center justify-center grey1 ttu pv1 pv2-l w-100"
      >
        <Icon
          path="arrow-left"
          width="32"
          height="18"
          className="banner--back__icon flex items-center"
        />
        <p className="ml1 mb0 h-5">{page.section}</p>
      </Link>
      {page.route === '/about-us/our-staff/' ? (
        <div>
          <div className="mt3 mt4-l mb2 mh2">
            <img src="https://venturerichmond.s3.amazonaws.com/DSC08388+copy.jpg" alt="Venture Richmond staff" />
          </div>
          <h1 className="dark h-2 h-1--l tc mb0 mt1 mb2 mh2">{page.title}</h1>
          <h2 className="mb0 mb3 mb4-l h-5 ttu tc mh2">{page.subtitle}</h2>
        </div>
      ) : (
        <div>
          <h1 className="dark h-2 h-1--l tc mb0 mt3 mt4-l mb2 mh2">{page.title}</h1>
          <h2 className="mb0 mb3 mb4-l h-5 ttu tc mh2">{page.subtitle}</h2>
        </div>
      )}

    </div>
  );
};

export default BackBanner;



// WEBPACK FOOTER //
// ./src/components/Banners/BackBanner.js